/* eslint @typescript-eslint/no-var-requires: "off" */
import { capitalize, TableCell, TableRow } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useNonprofitsData } from '../../Layout/nonprofitsContext/useNonprofitsData/useNonprofitsData'

import { Validation } from '@percent/admin-dashboard/api/types'
import { ReactComponent as DropdownSVG } from '@percent/admin-dashboard/common/assets/images/dropdown.svg'
import { CountryCodeFlag } from '@percent/admin-dashboard/common/components/countryCodeFlag/CountryCodeFlag'
import { getDate } from '@percent/admin-dashboard/common/utility/getDate'
import { handleClickAsLink } from '@percent/admin-dashboard/common/utility/handleClickAsLink'
import style from './ValidationRow.module.scss'

type ValidationRowProps = {
  row: Validation
}

export function ValidationRow({ row }: ValidationRowProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { setValidation } = useNonprofitsData()

  const validationRowClick = (validation: Validation) => {
    setValidation(validation)

    return handleClickAsLink(`/validations/${validation.id}`, navigate)
  }

  /* eslint-disable global-require */
  const countries = require('i18n-iso-countries')
  countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
  /* eslint-enable global-require */

  const registryName = row.organisation?.registryData?.name ?? row.organisation?.registry ?? row.registryName

  return (
    <TableRow key={row.id} onClick={validationRowClick(row)} className={style.row}>
      <TableCell>
        <CountryCodeFlag countryCode={row.countryCode} />
      </TableCell>
      <TableCell>{row.name}</TableCell>
      <TableCell data-testid="validationRow-registry">
        {registryName ? capitalize(registryName) : t('status.na')}
      </TableCell>
      <TableCell data-testid="validationRow-registryId">
        {row.organisation?.registryId ?? row.registryId ?? t('status.na')}
      </TableCell>
      <TableCell>{row.partner.name}</TableCell>
      <TableCell align="right" className={style.date} style={{ padding: '16px 50px 16px 0', textAlign: 'left' }}>
        {getDate(row.createdAt)}
      </TableCell>
      <TableCell align="right" className={style.rowIconForward} style={{ padding: '0' }}>
        <DropdownSVG className={style.arrow} />
      </TableCell>
    </TableRow>
  )
}
